/* dev/assets/js/a-video.js */
(function ($) {
    "use strict";
    $(function () {

/*         $('video').each(function () {
            enableInlineVideo(this);
        }); */

        $('.youtube-player').on('click', function () {
            $(this).html(`<iframe src="https://www.youtube-nocookie.com/embed/${$(this).data('id')}?autoplay=1&amp;rel=0&amp;enablejsapi=1" frameborder="0" allow="autoplay" allowfullscreen="1"></iframe>`);
        });

    });
})(jQuery);
